<template>
    <div class="mainPage">
        <div class="header_banner">
            <img src="../img/chinesebridge/m_top_bg.png" alt="" class="bg">
            <div class="header">
                <div class="content">
                    <div class="left">
                        <img src="../img/chinesebridge/camp_icon.png" alt="" class="camp">
                        <div class="schoolInfo">
                            <img :src="subject_info.extra.schoolLogo" alt="" v-if="subject_info.extra&&subject_info.extra.schoolLogo" class="logo">
                            <div class="name_en" :class="{'long_name':subject_info.name_en.length > 140}" v-if="subject_info.name_en">
                                {{subject_info.name_en}}
                            </div>
                            <div class="name" :class="{'long_name':subject_info.name_en.length > 140}">
                                {{subject_info.name}}
                            </div>
                        </div>
                    </div>
                    <div class="memuCon">
                        <img src="../img/chinesebridge/menu.png" alt="" @click="toggleMenu()">
                        <div class="menu" v-show="activeMenu">
                            <div class="menuUserName" v-if="isLogin">{{user.username}}</div>
                            <div class="logOut" v-if="isLogin" @click="toLogOut()">退出</div>
                            <div class="menuUserName" v-if="!isLogin" @click="toLogin()">登录</div>
                            <div class="logOut" v-if="!isLogin" @click="toLogin()">注册</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="courseListCon">
            <div class="liveClass">
                <img src="../img/chinesebridge/liveclass.png" alt="">
            </div>
            <div class="course_con" v-for="(v, i) in courseList" :key="i">
              <div class="meet_date" :id="v.date" @click="spreadMeet(v)">
                <div class="date">{{v.date}}</div>
                <div class="arrow">{{v.sonShow ? '一' : '+'}}</div>
              </div>
              <ul class="list" v-show="v.sonShow">
                  <li v-for="(item, index) in v.list" :key="item.id" :class="{'live': item.customStatus == 1, 'finished': item.customStatus == 2}">
                      <div class="timeCon" >
                          <span class="time">{{new Date(+item.start_time).Format('YYYY.MM.DD hh:mm')}}-{{new Date(+item.end_time).Format('hh:mm')}}</span>
                          <span class="status live" v-if="item.customStatus2 == 1 && item.customStatus !== 2">
                              Live 直播进行中
                          </span>
                          <span class="status finished" v-if="item.customStatus == 2">
                              Finished 直播已结束
                          </span>
                      </div>
                      <div class="nameCon">
                          <div class="name name_en" v-if="item.name_en">
                              <span>
                                  {{item.name_en}}
                              </span>
                          </div>
                          <div class="name" v-if="item.name">
                              <span>
                                  {{item.name}}
                              </span>
                          </div>
                      </div>
                      <div class="titleCon">
                          <div class="title">
                              <div class="en" v-if="item.teacher_name_en">
                                  {{item.teacher_name_en}}
                              </div>
                              <div class="cn" v-if="item.teacher_name">
                                  {{item.teacher_name}}
                              </div>
                          </div>
                          <div class="liveBtn">
                              <!-- <span class="join" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == false" @click="join(item, index, false)">
                                  <span class="En">
                                      Join
                                  </span>
                                  <span class="Cn">
                                      加入
                                  </span>
                              </span> -->
                              <span class="join replay" v-if="item.status == 3" @click="replay(item)">
                                  <span class="En">
                                      Replay
                                  </span>
                                  <span class="Cn">
                                      课程回放
                                  </span>
                              </span>
                              <span class="isOrder" v-if="item.status == 1 && item.customStatus == 0">
                                  直播未开始 Coming Soon
                              </span>
                              <span class="join" v-if="item.status == 1 && item.customStatus == 1" @click="joinToLive(item, index)">
                                  <span class="En">
                                      Enter
                                  </span>
                                  <span class="Cn">
                                      进入
                                  </span>
                              </span>
                          </div>
                      </div>
                  </li>
                  <!-- <div class="noMore">
                      <span>
                          No more 没有更多了 ...
                      </span>
                  </div> -->
              </ul>
            </div>
        </div>
        <transition name="fade">
            <div id="videoPlayWrapper" v-if="isPlay">
                <div class="videoContent">
                <div class="closeVideo" @click="closeVideo()">×</div>
                <div class="videoContainer">
									<!-- 普通视频 -->
									<video :src="currentVideoUrl" id="liveVideo" controls controlsList="nodownload" v-if='video_type==1'></video>
									<!-- 点播视频 -->
									<template v-else>
										<TCPlayer :options="options" style="width: 100%; height: 300px; margin: auto;" ></TCPlayer>
									</template>
								</div>
							</div>
            </div>
        </transition>
    </div>
</template>

<script>
import Qs from 'qs'
import TCPlayer from '../pc/common/TCPlayer'
export default {
    name: 'chinesebridge',
    components: {
			TCPlayer
    },
    data: function () {
        return {
					options:{
							fileID: "",
							appID: "1500035244",
							autoplay: true,
							psign:"",
						},
            activeMenu: false,
            isLogin: false,
            isPlay: false,
            currentVideoUrl: '',
						video_type: '',
            user: {
                username: '',
                email: ''
            },
            subject_info: {},
            courseList: [],
            subject_id: null,
            beforeTime: 30, // 提前可进入直播间时间
            beforeTime2: 0, // 提前可进入直播间时间
            afterTime: 30 // 延后关闭直播间时间
        }
    },
    methods: {
        tolive (url) {
            window.open(url)
        },
        toLogin() {
            window.location.href =
            this.baseUrl +
            "user/api/login?" +
            "callback=" +
            encodeURIComponent(window.location.href);
        },
        toRegister() {
            window.location.href = 'https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=' + encodeURIComponent(window.location.href);
        },
        customCheckLogin() {
            this.checkLogin().then(res => {
                if(res.data.success){
                    this.isLogin = true
                    this.user = res.data.data
                } else {
                    this.isLogin = false
                }
                this.getCourseInfo(this.subject_id)
            })
        },
        toLogOut() {
            this.$utils.get('/user/api/logout').then(res => {
                if(res.data.success) {
                    this.isLogin = false
                }
            })
        },
        // 获取专题信息
        getSubjectInfo(id) {
            this.$utils.get('/subject/subject/read', {
                id: id
            }).then(res => {
                if(res.data.success) {
                    this.subject_info = res.data.data
                }
            })
        },
        spreadMeet (v) {
          this.$set(v, 'sonShow', !v.sonShow)
          // this.meetShowMap.forEach((v, i) => {
          //   if (index == i) this.$set(v, 'sonShow', !v.sonShow)
          //   else this.$set(v, 'sonShow', false)
          // })
        },
        // 获取课程列表
        getCourseInfo(id) {
            this.$utils.get('/subject/lesson/getlist', {
                subject_id: id,
                limit: 200,
                type: 'date'  
            }).then(res => {
                if(res.data.success) {
                    var now = new Date().getTime()
                    var endTime = now - this.afterTime * 60 * 1000;
                    var nowBeforeFiveMin = now + this.beforeTime * 60 * 1000
                    var nowBeforeFiveMin2 = now + this.beforeTime2 * 60 * 1000
                    res.data.data.list.forEach(item => {
                      item.sonShow = new Date().Format('YYYY-MM-DD') == item.date ? true : false
                      item.list.forEach(e => {
                        e.isOrder = false
                        e.customStatus = 0
                        if (nowBeforeFiveMin > e.start_time) {
                            e.customStatus = 1 // 0:直播未开始 1:正在直播 2：直播已结束
                        }
                        if (endTime > e.end_time) {
                            e.customStatus = 2
                        }
												if (nowBeforeFiveMin2 > e.start_time) {
                            e.customStatus2 = 1 // 0:直播未开始 1:正在直播 2：直播已结束
                        }
                      })
                    })
                    this.courseList = res.data.data.list
                    var sonShowFlag = this.courseList.every(item => !item.sonShow)
                    if (sonShowFlag) {
                      if (new Date().getTime() < this.courseList[0]['list'][0].start_time) {
                        this.courseList[0].sonShow = true
                      } else if (new Date().getTime() > this.courseList[this.courseList.length - 1]['list'][0].end_time) {
                        this.courseList[this.courseList.length - 1].sonShow = true
                      } else {
                        this.findDate(new Date().Format('YYYY-MM-DD'))
                      }
                    }
                    this.$nextTick(() => {
                      this.courseList.forEach(item => {
                        item.sonShow && this.hashJump(item.date)
                      })
                    })
                    // this.checkOrdeList()
                }
            })
        },
        findDate (chartDate) {
          var dateIndex = this.courseList.findIndex(item => {
            return chartDate == item.date
          })

          if (dateIndex == -1) {
            var nextDate = new Date(new Date(chartDate).getTime() + 86400000).Format('YYYY-MM-DD')
            this.findDate(nextDate)
          } else {
            this.courseList[dateIndex].sonShow = true
          }
        },
        // 跳转锚点
        hashJump (id) {
          try {
            // window.document.getElementById(id).scrollIntoView(true)
            var distance = window.document.getElementById(id).offsetTop
            window.scrollTo({
              top: distance - 200,
              behavior: "auto",
            })
          } catch (err) {
          }
        },
        // 检查可预约直播间
        checkOrdeList() {
            const orderRoomId = []
            this.courseList.forEach(e => {
                if (orderRoomId.indexOf(e.room_id) == -1 && e.room_id != 0) {
                    orderRoomId.push(e.room_id)
                }
            })
            this.checkRoomsIsOrder(orderRoomId)
        },
        // 检查用户直播间状态
        checkRoomsIsOrder(arr) {
            const data = Qs.stringify({
                rooms: arr.toString(),
                user: this.user.email
            })
            this.$utils.thirdPost('https://mooc-live.chineseplus.net/api/live/get-user-rooms'+"?time=" +new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList.forEach((e, index) => {
                        if (res.data.data.hasOwnProperty(e.room_id)) {
                            this.courseList[index].isOrder = true
                            this.$set (this.courseList, index, this.courseList[index])
                        }
                    })
                } else {
									this.$message.error(res.data.msg)
								}
            })
        },
        join(item, index, islive) {
            if(!this.isLogin) {
                this.toLogin()
                return
            }
            const data = Qs.stringify({
                room_id: item.room_id,
                user: this.user.email,
                secret: "faaf827fa8e4941ad5317a5a0b0f9649",
                key: "mooc",
                username: this.user.username,
                realname: this.user.username
            })
            this.$utils.thirdPost('https://mooc-live.chineseplus.net/api/live/add-user'+"?time=" +new Date().valueOf(), data, {
                headers: {
                    // 'Content-Type': 'application/json'
										'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList[index].isOrder = true
                    this.$set (this.courseList, index, this.courseList[index])
                    if (islive) {
                        window.location.href = 'https://mooc-live.chineseplus.net/p/#/?meeting_id=' + item.room_id
                    }
                } else {
									this.$message.error(res.data.msg)
								}
            }).catch((r) => {
                console.log(r)
            })
        },
        joinToLive(item, index) {
            if(!this.isLogin) {
                this.toLogin()
                return
            }
            // if(!item.isOrder) {
            //     this.join(item, index, true)
            // }
						else {
                window.location.href = 'https://mooc-live.chineseplus.net/p/#/?meeting_id=' + item.room_id
            }
        },
        async replay(item) {
            if(!this.isLogin) {
                this.toLogin()
                return
            }
            this.currentVideoUrl = item.video_url
						this.video_type = item.video_type
						// 点播获取视频签名
						if(item.video_type == 2){
							let res = await this.$utils.get("/subject/lesson/getvideoauth", {
								vid: item.video_id,
							});
							if (res.data.success) {
								this.options.fileID = item.video_id;
								this.options.psign = res.data.data;
							}
						}
						this.isPlay = true
            // setTimeout(function() {
            //     $('#liveVideo').bind('contextmenu',function() { return false; })
            // }, 50)
        },
        closeVideo() {
            var myvideo = document.getElementById("liveVideo");
            if (myvideo && !myvideo.paused) {
                myvideo.pause();
            }
            this.isPlay = false
        },
        toggleMenu() {
            this.activeMenu = !this.activeMenu
        }
    },
    mounted() {
        this.subject_id = this.$route.query.id
        this.customCheckLogin()
        this.getSubjectInfo(this.subject_id)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mainPage {
    width: 100%;
    text-align: center;
    position: relative;
    min-height: 100%;
    .header_banner {
        width: 100%;
        position: relative;
        overflow: hidden;
        .bg {
            width: 100%;
        }
        .header {
            width: 100%;
            position: absolute;
            top: 0.65rem;
            z-index: 1;
            .content {
                width: 100%;
                margin: auto;
                .left {
                    display: inline-block;
                    width: 100%;
                    .camp {
                        width: 64%;
                    }
                    .schoolInfo {
                        .logo {
                            height: 0.83rem;
                            margin-top: 0.23rem;
                        }
                        .name {
                            width: 100%;
                            padding: 0 0.5rem;
                            font-size: 0.3rem;
                            line-height: 1.2;
                            box-sizing: border-box;
                            text-align: left;
                            color: #004b9d;
                            font-weight: bold;
                            margin-top: 0.1rem;
                        }
                        .name_en {
                            width: 100%;
                            font-size: 0.31rem;
                            padding: 0 0.5rem;
                            box-sizing: border-box;
                            text-align: left;
                            font-family: "DINCond-Medium";
                            color: #004b9d;
                            margin-top: 0.26rem;
                        }
                        .long_name {
                            font-size: 0.28rem;
                        }
                    }
                }
                .memuCon {
                    position: absolute;
                    right: 0.43rem;
                    top: -0.1rem;
                    font-size: 0;
                    img {
                        width: 0.49rem;
                    }
                    .menu {
                        position: absolute;
                        right: 0;
                        top: 0.55rem;
                        background-color: #fff;
                        width: 100px;
                        border-radius: 0.05rem;
                        padding: 0.1rem 0;
                        font-size: 0.3rem;
                        div {
                            color: #333;
                            text-align: center;
                            line-height: 200%;
                        }
                    }
                }
            }
        }
    }
    .courseListCon {
        margin: auto;
        background-color:#fff;
        padding: 0 0.1rem;
        margin-top: 0.2rem;
        .liveClass {
            padding-top: 0.25rem;
            width: 100%;
            text-align: center;
            margin-bottom: .4rem;
            img {
                width: 2.78rem;
            }
        }
        .course_con {
          margin-bottom: .15rem;
        }
        .meet_date {
          overflow: hidden;
          background-color: #ffffff;
          border-radius: .1rem;
          border: solid .03rem #7ecef4;
          cursor: pointer;
          font-size: .6rem;
          font-weight: bold;
          padding: .26rem .5rem;
          &:hover {
            background-color: #7ecef4;
            .date {
              color: #fff;
            }
            .arrow {
              color: #fff;
            }
          }
          .date {
            font-family: DIN-Bold;
            font-weight: bold;
	          font-size: .48rem;
            color: #55add7;
            float: left;
            margin-top: 5px;
          }
          .arrow {
            float: right;
            margin-top: -.05rem;
            cursor: pointer;
            color: #55add7;
          }
        }
        .list {
            position: relative;
            padding: 0 0.14rem;
            text-align: left;
            margin-top: 0.4rem;
            margin-bottom: 1.4rem;
            &:before {
                position: absolute;
                left: 0.16rem;
                width: 0.08rem;
                height: calc(100% + 1rem);
                content: '';
                background-color: #7ecef4;
            }
            li {
                margin-left: 0.42rem;
                margin-bottom: 1.1rem;
                position: relative;
                &:before {
                    position: absolute;
                    left: -0.48rem;
                    content: '';
                    width: 0.24rem;
                    height: 0.24rem;
                    box-sizing: border-box;
                    box-sizing: border-box;
                    border-radius: 100%;
                    border: 0.06rem solid #7ecef4;
                    background-color: #fad46b;
                }
                .timeCon {
                    font-size: 0;
                    .time {
                        font-size: 0.28rem;
                        color: #5e696d;
                        font-family: "DIN-Medium";
                        vertical-align: top;
                    }
                    .live {
                        float: right;
                        font-size: 0.21rem;
                        color: #379346;
                        vertical-align: middle;
                        font-family: "Georgia";
                    }
                    .finished {
                        float: right;
                        font-size: 0.21rem;
                        color: #93a4aa;
                        vertical-align: middle;
                        font-family: "Georgia";
                    }
                }
                .nameCon {
                    margin-top: 0.26rem;
                    margin-bottom: 0.3rem;
                    font-size: 0.28rem;
                    .name {
                        font-size: 0.28rem;
                        line-height: 1.2;
                        color: #364347;
                    }
                    .name_en {
                        font-size: 0.28rem;
                        line-height: 1.2;
                        color: #5e696d;
                        margin-bottom: 8px;
                        font-family: 'Georgia';
                    }
                }
                .titleCon {
                    font-size: 0.25rem;
                    height: 0.6rem;
                    width: 100%;
                    .title {
                        color: #009dcd;
                        display: inline-block;
                        width: calc(100% - 2.5rem);
                        .en {
                            font-size: 0.25rem;
                            font-family: 'Georgia';
                            margin-bottom: 0.02rem;
                            width: 100%;
                            line-height: 1.2;
                        }
                        .cn {
                            font-size: 0.25rem;
                            width: 100%;
                            line-height: 1.2;
                        }
                    }
                    .liveBtn {
                        float: right;
                        display: inline-block;
                        font-family: 'Georgia';
                        color: #282828;
                        .join {
                            display: inline-block;
                            height: 0.6rem;
                            line-height: 1.2;
                            border-radius: 0.28rem;
                            background-color: #fcb922;
                            padding: 0.15rem 0.22rem;
                            box-sizing: border-box;
                            cursor: pointer;
                            .En {
                                font-size: 0.26rem;
                                vertical-align: top;
                            }
                            .Cn {
                                font-size: 0.24rem;
                                vertical-align: top;
                            }
                        }
                        .replay {
                            background-color: #7ecef4;
                        }
                        .isOrder {
                            color: #999;
                            font-size: 0.24rem;
                        }
                    }
                }
            }
            .live:before {
                background-color: #43fd61;
            }
            .finished:before {
                background-color: #d6e1e5;
            }
            .noMore {
                font-size: 0.25rem;
                margin-left: 0.4rem;
                color: #7ecef4;
                position: relative;
            }
            .noMore:after {
                position: absolute;
                right: 0;
                z-index: 1;
                top: 0.18rem;
                display: inline-block;
                content: '';
                height: 0.03rem;
                width: calc(100% - 2.8rem);
                background-color: #7ecef4;
            }
        }
    }
    #videoPlayWrapper {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 999;
        }
    #videoPlayWrapper .closeVideo {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
    }
    .videoContent {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .videoContainer {
        text-align: center;
        width: 100%;
    }
    .videoContainer video {
        width: 100%;
    }
}

</style>
